var BestSellerJS = (function () {

    function initBestsellerCarousel() {
        var jCarousel = $('div.bestseller.jcarousel');
        jCarousel.jcarousel({
            vertical: true,
            wrap: 'circular',
            animation: false
        }).jcarouselAutoscroll({
            interval: 5000
        });
        jCarousel.on('jcarousel:visiblein', 'li', function(event, carousel) {
            jCarousel.css('display', 'none');
            jCarousel.fadeIn(2000);
        });
    }

    function repositionBestseller(){
        if($(window).width() < 768){
            var bestsellerDiv = $(".bestseller.jcarousel");
            var bestsellerContents = bestsellerDiv.html();
            bestsellerDiv.insertAfter(".home-search-form");
            bestsellerDiv.append(bestsellerContents);
        }
    }

    return {
        initBestsellerCarousel:initBestsellerCarousel,
        repositionBestseller: repositionBestseller
    }
})(jQuery);

$(document).ready(function() {
    BestSellerJS.initBestsellerCarousel();
    BestSellerJS.repositionBestseller();
});

$(window).on('resize', function(){
    BestSellerJS.repositionBestseller();
});